import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'running-comparison-report-shared',
  templateUrl: 'running-comparison-report-shared.component.html',
})
export class RunningComparisonReportSharedComponent implements OnInit {
  initialized = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.initialized = true;
  }
}
